module.exports = __webpack_public_path__ + "static/fipclemonbrave1-bfcffe667a4ced68ef260f8951a9008f.jpeg";